<template>
  <div class="chat-body">
    <div class="search-wrap">
      <el-button size="mini" type="primary text2" @click="edit(null)" icon="el-icon-plus">添加分类</el-button>

      <!-- 添加窗口 -->
        <el-dialog :title="'编辑' + (addType ? '关键字' : '分类')" :visible.sync="dialogFormVisible" width="500px">
          <!-- <div class="add-type">
            <el-radio-group v-model="addType" size="medium">
              <el-radio-button label="1">关键字</el-radio-button>
              <el-radio-button label="0">分类</el-radio-button>
            </el-radio-group>
          </div> -->
          <el-form :model="form" :rules="rules" ref="keywordForm" style="margin-right: 50px;">
            <el-form-item label="分类" prop="parent_id" :label-width="formLabelWidth" v-if="addType == 1">
              <el-select v-model="form.parent_id" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
              <el-input v-model="form.name" autocomplete="off" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="排序" :label-width="formLabelWidth">
              <el-input v-model="form.sort" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('keywordForm')" class="text2">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 添加窗口 -->

    </div>

    <div class="table-wrap-c">
      <el-table :max-height="__TABLE_HEIGHT__" v-loading="loading" default-expand-all class="chat-table" :data="tableData" row-key="id">
        <el-table-column prop="name" label="分类" width="120"></el-table-column>
        <el-table-column label="关键字">
          <template slot-scope="scope">
            <div class="tag-list" v-if="scope.row.keywords.length">
              <el-tag :key="tag.id" v-for="tag in scope.row.keywords" size="default" closable :disable-transitions="false" @close="handleClose(tag)"><a @click="edit(tag)" href="javascript:;">{{ tag.name }}</a></el-tag>
            </div>
            <el-input class="input-new-tag" v-if="scope.row.inputVisible" v-model="scope.row.inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm(scope)" @blur="handleInputConfirm(scope)"></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput(scope)">+ 添加关键字</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button class="text2" type="primary" size="mini" round icon="el-icon-edit-outline" @click="edit(scope.row)">编辑</el-button>
            <el-button class="text2" type="danger" size="mini" round icon="el-icon-delete" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>

export default {
  name: "ConversationKeyword",
  data () {
    return {
      keyword: '',
      dialogFormVisible: false,
      addType: 1,
      form: {
        id: 0,
        name: '',
        sort: 0,
        parent_id: 0,
      },
      rules: {
        parent_id: [
          { required: true, message: '请输选择分类', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入关键字', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
      },
      formLabelWidth: '80px',
      tableData: [],
      loading: false,
      typeList: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  created() {
    this.getAllKeywords()
  },
  computed:{
    __TABLE_HEIGHT__(){
      return (window.outerHeight - 290) + 'px'
    }
  },
  methods: {
    search() {

    },
    remove(item) {

      this.$confirm('是否删除'+(item.parent_id > 0 ? '该关键字' : '该分类及分类下所有关键字')+'?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$qwhttp.post('keyword/remove', {id: item.id}).then( res => {
          if(res.status == 200) {
            if(res.data.errcode == 0) {
              this.$message.success("操作成功！");
              this.getAllKeywords()
            } else {
              this.$message.error(res.data.msg);
            }
          }
        });
      })


    },
    edit(item) {
      if(item && item.parent_id == 0) item.parent_id = ''
      this.form = Object.assign({
        id: 0,
        name: '',
        sort: 0,
        parent_id: '',
      }, item)
      this.addType = item && item.parent_id > 0 ? 1 : 0
      this.dialogFormVisible = true
      this.resetForm('keywordForm')
    },
    getAllKeywords() {
      const that = this
      that.loading = true
      that.$qwhttp.get('keyword/all').then( res => {
        if(res.status == 200) {
          let typeList = []
          let tableData = []
          if(res.data.data != null) {
            res.data.data.forEach(item => {
              if(item.parent_id == 0) {
                typeList.push(item)
                item.inputVisible = false
                item.inputValue = ""
                tableData.push(Object.assign(item, {keywords: that.getKeywords(res.data.data, item.id)}))
              }
            })
          }
          that.tableData = tableData
          that.typeList = typeList
        }
        that.loading = false
      });
    },
    getKeywords(list, parentId) {
      return list.filter(item => {
        return item.parent_id == parentId
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            id: Number(this.form.id),
            parent_id: this.addType == 1 ? Number(this.form.parent_id) : 0,
            sort: Number(this.form.sort),
            name: this.form.name
          }

          if(data.id > 0 && data.id == data.parent_id) {
            this.$message.warning("请选择另外一个分类！")
            return false
          }

          this.$qwhttp.post('keyword/update', data).then( res => {
            if(res.status == 200) {
              if(res.data.errcode == 0) {
                this.$message.success("操作成功！");
                this.dialogFormVisible = false
                this.getAllKeywords()
              } else {
                this.$message.error(res.data.msg);
              }
            }
          });
        } else {
          return false;
        }
      });
    },

    resetForm(formName) {
      if(this.$refs[formName]) this.$refs[formName].resetFields();
    },
    handleClose(tag) {
      this.remove(tag)
    },

    showInput(scope) {
      let row = this.tableData[scope.$index]
      row.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm(scope) {
      let row = this.tableData[scope.$index]
      row.inputVisible = false
      if(row.inputValue != "") {

        this.$qwhttp.post('keyword/update', {id: 0, parent_id: row.id, sort: 0, name: row.inputValue}).then( res => {
          if(res.status == 200) {
            if(res.data.errcode == 0) {
              this.$message.success("操作成功！");
              this.getAllKeywords()
            } else {
              this.$message.error(res.data.msg);
            }
          }
        });

        row.inputValue = ''

      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .text2,.el-button--primary {
    color: #FFFFFF;
  }
  .add-type {
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
  }
  .search-wrap {
    padding-bottom: 15px;
    border-bottom: 1px solid #EBEEF5;
  }
  .chat-body {
    position: relative;
    padding: 15px;
  }
  .keyword-tag {

    margin-right: 5px;
  }
  .el-tag {
    margin-top: 3px;
    margin-bottom: 3px;
    margin-right: 7px;
  }
  .tag-list {
    display: inline-block;
    margin-right: 3px;
  }
  .el-tag:last-child {
    margin-right: 0;
  }
  .button-new-tag {
    width: 100px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .input-new-tag {
    margin-top: 3px;
    margin-bottom: 3px;
    width: 100px;
    vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Conversation/Keyword.vue